// Mock SecureStorageService for demo
export class SecureStorageService {
  private static storage: { [key: string]: string } = {};

  static async get(key: string): Promise<string | null> {
    return this.storage[key] || null;
  }

  static async set(key: string, value: string): Promise<void> {
    this.storage[key] = value;
  }

  static async remove(key: string): Promise<void> {
    delete this.storage[key];
  }
}

